import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DailyLegLoadsLogComponentPage } from '../daily-leg-loads-log-component/daily-leg-loads-log-component';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-daily-leg-loads-log',
  templateUrl: 'daily-leg-loads-log.html',
})
export class DailyLegLoadsLogPage {
  @ViewChild('legLoadsComponent') legLoadsComponent: DailyLegLoadsLogComponentPage;

  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  ionViewDidEnter() {
    this.legLoadsComponent.reEnterComponent();
  }

  ionViewWillLeave() {
    this.legLoadsComponent.saveBeforeLeavingComponent();
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-loads-log/daily-leg-loads-log.ts